import { useWorkspaceSetup } from '../../contexts/setup-workspace-context'
import { CompanyConfirmation } from './company-confirmation'
import { ConfirmationStep } from './confirmation-step'
import { EmailAddress } from './email-address'
import { MCOrDOTNumber } from './mc-or-dot-number'
import { ReceiveCodeMethodForPhone } from './receive-code-method-for-phone'
import { RequestCustomVerification } from './request-custom-verification'
import { SelectMCOrDOTType } from './select-mc-or-dot-type'
import { SelectVerificationMethod } from './select-verification-method'
import { VerificationOTP } from './verification-otp'

/**
 * This component is used to render the correct step component based on the step number
 */
const stepComponents: Record<number, React.FC<{ onClose?: () => void }>> = {
  2: SelectMCOrDOTType,
  3: MCOrDOTNumber,
  4: CompanyConfirmation,
  5: SelectVerificationMethod,
  6: ReceiveCodeMethodForPhone,
  7: EmailAddress,
  8: VerificationOTP,
  9: RequestCustomVerification,
  10: ConfirmationStep
}

export const StepRenderer = ({ onClose }: { onClose?: () => void }) => {
  const { step } = useWorkspaceSetup()
  const StepComponent = stepComponents[step]

  return StepComponent ? <StepComponent onClose={onClose} /> : null
}
